// HTTP wrapper for the script-editor backend: load and save procedures,
// functions, and views. All three share the same DROP+CREATE script shape
// (see internal/mysql/schema.go::LoadProcedure / LoadFunction / LoadView).
import { api } from './api.js';

// kind is 'procedure' | 'function' | 'view'.
const PATH = {
  procedure: 'procedures',
  function:  'functions',
  view:      'views',
  event:     'events',
};
const PARAM = {
  procedure: 'sp',
  function:  'fn',
  view:      'view',
  event:     'event',
};

function pathFor(kind) {
  const p = PATH[kind];
  if (!p) throw new Error(`unknown routine kind: ${kind}`);
  return p;
}

export async function loadRoutine(connectionId, database, kind, name) {
  const seg = pathFor(kind);
  const r = await api.get(
    `/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/${seg}/${encodeURIComponent(name)}`
  );
  return r;
}

export async function saveRoutine(connectionId, database, kind, script) {
  const seg = pathFor(kind);
  return api.post(
    `/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/${seg}`,
    { script }
  );
}

// Path parameter name used by the GET handler (mostly informational).
export function routineParam(kind) { return PARAM[kind]; }

// Set a stored FUNCTION's MySQL SQL DATA ACCESS characteristic (ALTER FUNCTION).
// access ∈ 'MODIFIES SQL DATA' | 'READS SQL DATA' | 'CONTAINS SQL' | 'NO SQL'.
// This is the flag the read-only-skips-transaction optimization reads.
export async function setFunctionDataAccess(connectionId, database, name, access) {
  return api.patch(
    `/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/functions/${encodeURIComponent(name)}`,
    { dataAccess: access }
  );
}
